<style>
    .nowmodal .vview-modal-mask,.nowmodal .vview-modal-wrap{
        z-index: 10000 !important;
    }
</style>
<template>
    <div class="proofing">
        <!-- 选择打样工厂、打样信息录入，报价确认 -->
        <div v-if="querytype=='submitoffer'" >
            <vButton theme="primary" @click="alertBox('passAudit')">报价审核通过</vButton>
            <vButton class="pull-right" @click="alertBox('reviewAudit')">审核驳回</vButton>
        </div>
        <compFormQuery class="margin-top-15 margin-right-15" :formdata="getBase" :value="querydata" :labelWidth="140"></compFormQuery>
        <div v-if="querytype!='entrynews'" class="text-right">
            <vButton theme="primary" class="margin-left-5" @click="alertBox('exportexcel')">导出</vButton>
        </div>
         <!-- 报价公司table -->
         <compWrapper class="margin-top-15" title="报价公司" theme="info" style="z-index:10">
        <vTableSimple
            class="margin-10"
            :columns="compcolumns"
            :data="datalist"
            border
            size="small" 
				ref="tableedit"
        ></vTableSimple>
         </compWrapper>

        <vButton v-if="querytype=='entrynews'" class="margin-top-10" theme="primary" @click="alertBox('uploadNews')">上传打样报告</vButton>

       
        <compWrapper class="margin-top-15" title="报告" theme="warning">
             <vTable
                class="margin-10"
                v-for="(item,index) in datalist"
                :key="index"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="getRequestData(item,index).length>0 && item.attachMeta!=null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
            <vTable
                class="margin-10"
                v-for="(item,index) in datalist"
                :key="index"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="item.attachMeta===null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
         <!-- 附件下载 -->
        <compWrapper v-if="showDocList" class="margin-top-15" title="附件" theme="primary">
            <vTableSimple
                class="margin-10"
                :columns="attachlog"
                :data="docList"
                border
            ></vTableSimple>
        </compWrapper>

        <div class="text-right margin-top-10">
            <vButton v-if="querytype=='chosefactory' || querytype=='entrynews'" theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-5" @click="close">取消</vButton>
        </div>

        <!-- 全局弹框 -->
        <compModal
            class="nowmodal"
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" @on-close="closemodalprops" v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
    </div>
</template>

<script>
import { HttpCheckOfferOne, HttpCancelOfferOne, HttpGetOfferList, HttpGetPrimaryOne, HttpSubmitProofing, HttpCheckProofing, HttpUploadRecommendAttach, HttpDeleteBaogao } from "@/service/proddevelop";
import compseleMutiul from './selectmutiupload';

import mixin from '../../mixins'

export default {
    components: {
        compseleMutiul,
    },
    mixins: [mixin],
    props:['querytype','querydata','showDocList'],
    data(){
        return {
            datalist:[],
            modalProps:{},
            docList:[],
        }
    },
    created(){
        this.update()
    },
    computed:{
        getBase(){
            return [
                {
					label: "预编码",
					key: "precoding",
                },
                {
					label: "状态",
                    key: "orderstatus",
                    tag: "vSelect",
                    options:this.getPrimaryStatus,

                },
            ]
        },
        compcolumns(){
            let _this = this;
            return [
                {
					title: "是否选中",
                    key: "id",
                    // tag:"vRadio",
                    width:this.querytype == 'submitoffer' ? 100 : 0,
                    render:(h,{row,index})=>{
                        if(this.querytype == 'submitoffer'){
                            if(row.status == 2){
                                return h('vButton', {
                                    props: {
                                        theme: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        'margin-right': '15px'
                                    }
                                }, '已选中')
                            }else{
                                return h('vButton', {
                                    props: {
                                        theme: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.updateDatalist(row,index);
                                        }
                                    },
                                    style: {
                                        'margin-right': '15px'
                                    }
                                }, '选中')
                            }
                        }else{
                            return <div>{row.status == 2 ? '是':'否'}</div>
                        }
                    }
                },
                {
					title: "报价公司名称",
					key: "companyName",
                },
                {
					title: "生产提前期",
					key: "productionCycle",
                },
                {
					title: "最小起订量",
					key: "minOrderQty",
                },
                {
					title: "报价（USD/CNY）",
                    key: "offerUsd",
                    width:90,
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.offerUsd || '--'}</div>
                            <div>{row.offerCny || '--'}</div>
                        </div>
                    }
                },
                {
					title: "报价有效期",
					key: "validPeriodTime",
                },
                {
					title: "是否需要打样",
                    key: "isNeedProofing",
                    render:(h,{row,index})=>{
                        if(this.querytype == 'chosefactory' && row.isNeedProofing != 1){
                            return h('vCheckbox',{
                                props:{
                                    value: row.isNeedProofing == 1 ? true : false,
                                },
                                on: {
                                    'on-change':(value) => {
                                        this.datalist[index].isNeedProofing = value == true ? 1 : 0
                                    }
                                },
                            })
                        }else{
                            return <div>{row.isNeedProofing == 1 ? '是':'否'}</div>
                        }
                    }
                },
                {
					title: "是否已打样",
                    key: "isProofing",
                    render:(h,{row,index})=>{
                        if(this.querytype == 'entrynews' && row.isProofing != 1){
                            return h('vCheckbox',{
                                props:{
                                    value: row.isProofing == 1 ? true : false,
                                },
                                on: {
                                    'on-change':(value) => {
                                        this.datalist[index].isProofing = value == true ? 1 : 0
                                    }
                                },
                            })
                        }else{
                            return <div>{row.isProofing == 1 ? '是':'否'}</div>
                        }
                    }
                },
                {
                    title: "样品预计完成日期",
                    key:'estimatedFinishTime',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'submitoffer'){
                            return <div>{row.estimatedFinishTime}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    
                                    format:'yyyy-mm-dd' + ' 00:00:00',
                                    confirm: false,
                                    value:_this.datalist[index].estimatedFinishTime
                                },
                                on: {
                                    'on-change':function(date){
                                        // console.log(date)
                                        _this.datalist[index].estimatedFinishTime = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'备注',
                    key:'proofingRemark',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'submitoffer'){
                            return <div>{row.proofingRemark}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.proofingRemark
                                },
                                on: {
                                    'input':(event) => {
                                        row.proofingRemark = event
                                        _this.datalist[index] = row
                                    }
                                },
                            })
                        }
                    }
                }   
            ]
        },
        attachlog(){
            return [
                {
                    title: '附件名称',
                    key: "attachTitle"
                },
                {
                    title: 'URL',
                    key: "attachUrl"
                },
                // {
                //     title: '操作人',
                //     key: "attachName"
                // },
                {
                    title: '操作时间',
                    key: "attachOpAt"
                },
                {
                    title: '操作',
                    render:(h, { row, index })=>{
                        return h('vButton', {
                            props: {
                                theme: "error",
                                size: 'small',
                            },
                            on: {
                                click: () => {
                                    this.download(row)
                                }
                            },
                            style: {
                                'margin-right': '15px'
                            }
                        }, '下载')
					}
                },
            ]
        },
        baogaocolumns(){
            let _this = this
            return [
				{
					title: '报告名称',
                    key: 'attachTitle',
                    render:(h,{row})=>{
                        return <a href={row.attachUrl} target="_blank">{row.attachTitle}</a>
                    }
                }, 
                {
					title: '操作时间',
                    key: 'attachOpAt'
                },
                {
					title: '操作人',
                    key: 'createdName'
                },
				{
					title: '操作',
                    // width: 120,
                    render(h, { row, index }) {
                        let delButton = ''
                        if (_this.type !== 'query') {
                            delButton = h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        _this.remove(row)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        }
						return h('div', [
							delButton,
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
    },
    methods:{
        getRequestData(item,index){
            if(item.attachMeta){
                let arraylist = JSON.parse(item.attachMeta).items;
                arraylist.map(jsonone=>{
                //   console.log(jsonone)
                  jsonone.orderid = item.id
                })

                // console.log(arraylist)
                return arraylist
            }else{
                return []
            }
        },
        downfile(url){
            this.handleWebfs(url, {}, 'download')
        },
        remove(row){
            // console.log(row)
            HttpDeleteBaogao({
                offerId:row.orderid,
                fileName:row.attachTitle,
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.update();
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
        updateDatalist(row,index){
            // console.log(row,index,'row,index)row,index)')
            this.datalist.map((item,itemindex)=>{
                if(item.id == row.id){
                    this.$set(this.datalist,itemindex,{...item,status:2});
                }else{
                    this.$set(this.datalist,itemindex,{...item,status:1});
                }
            })
        },
        download(row){
            this.handleWebfs(row.attachUrl, {}, 'download')
        },
        update(){
            HttpGetOfferList({
                'search[EQ_preselectionId]':this.querydata.orderid,
                row:20,
                page:1,
            }).then(res=>{
                this.datalist = res.data.content;
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            HttpGetPrimaryOne({
                id:this.querydata.orderid
            }).then(res=>{
                this.docList = res.data.attachMeta ? JSON.parse(res.data.attachMeta).items : [];
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        alertBox(type){
            switch(type){
                case 'passAudit':
                    let factory = this.datalist.filter(item=>{
                        return item.status == 2
                    })[0] || {}
                    if(!factory.id){
                        this.$VMessage.error('请先选中报价公司'); return;
                    }
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: "点击确认按钮，报价将审核通过，请谨慎操作！",
                        width: 460,
                        showDesc:false,
                        params:{id:factory.id},
                        formdata: [
                            {
                                label: "供应商",
                                valueText: factory.companyName,
                                span: 24,
                                query:true
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpCheckOfferOne,
                        callback:()=>{
                            this.$emit('on-update');
                            // this.update()
                            this.modalProps.show = false;
                        }
                    };
                break;
                case 'reviewAudit':
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: "报价驳回",
                        width: 460,
                        showDesc:false,
                        params:{preselectionId:this.querydata.orderid},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                            }
                        ],
                        ajaxRequest:HttpCancelOfferOne,
                        callback:()=>{
                            this.$emit('on-update');
                            // this.update()
                            this.modalProps.show = false;
                        }
                    };
                break;
                case 'exportexcel':
                    if(this.querytype == 'chosefactory'){
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/export', {type:1,preselectionId:this.querydata.orderid}, 'download')
                    }else{
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/export', {type:0,preselectionId:this.querydata.orderid}, 'download')
                    }
                    break;
                case 'uploadNews':
                    this.modalProps = {
                        show: true,
                        title: '上传打样报告',
                        width:460,
                        srcLabelid: this.querydata.orderid,
                        actionurl: process.env.VUE_APP_APIURL_UC + "/api/v1/BizAttach/uploadFile",
                        name: "multipartFile",
                        component: "compseleMutiul",
                        showFooter: false,
                        optionlist:this.datalist,
                        factory:1,
                        formdata:[
                            {
                                span: 24,
                                label: '请选择工厂名称',
                                key: 'companyName',
                                tag: 'vSelect',
                                props: {
                                    strict: false,
                                },
                                options: this.datalist.map(item=>{
                                    return {
                                        value:item.companyName,
                                        label:item.companyName,
                                    }
                                })
                            },
                        ],
                        on:{
                            'on-update':()=>{
                                // this.$emit('on-update');
                                this.update()
                            // this.modalProps.show = false;
                            }
                        }
                    }
                    break;
            }
        },
        succesUpload(){
            HttpUploadRecommendAttach({
                preselectionId: this.querydata.orderid || 0,
                attach: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                    organizationId: global.SYSID
                }),
            }).then(res => {
                this.$VMessage.success(res.message)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        submit(){
            // console.log(this.datalist)
            let array = [],arr = [];
            this.datalist.map(item=>{
                if(item.isNeedProofing == 1){
                    array.push(item.id)
                }
                if(item.isProofing == 1){
                    arr.push(item.id)
                }
            })
            switch(this.querytype){
                case 'chosefactory':
                    
                    let arraylist1 = [];
                    this.datalist.map(item=>{
                        let data = {
                            // orgId:global.SYSID,
                            offerId:item.id,
                            isProofing:item.isNeedProofing ? item.isNeedProofing : 0,
                            estimatedFinishTime:item.estimatedFinishTime ? item.estimatedFinishTime : null,
                            proofingRemark:item.proofingRemark
                        }
                        arraylist1.push(data)
                    })

                    HttpSubmitProofing({
                        orgId:global.SYSID,
                        list:arraylist1
                        }).then(res=>{
                        this.$VMessage.success(res.message);
                        this.$emit('on-update');
                    },err=>{
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    })

                    
                    break;
                case 'entrynews':
                    let arraylist = [];
                    this.datalist.map(item=>{
                        let data = {
                            // orgId:global.SYSID,
                            offerId:item.id,
                            isProofing:item.isProofing ? item.isProofing : 0,
                            estimatedFinishTime:item.estimatedFinishTime ? item.estimatedFinishTime : null,
                            proofingRemark:item.proofingRemark
                        }
                        arraylist.push(data)
                    })
                    HttpCheckProofing({
                        orgId:global.SYSID,
                        list:arraylist
                        }).then(res=>{
                        this.$VMessage.success(res.message);
                        this.$emit('on-update');
                    },err=>{
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    })
                    break;
            }
        },
        close(){
            this.$emit('on-close')
        }
    },
}
</script>
